@if (defaultColors) { @for (option of defaultColors; track option) {
<div class="outer-color-option">
  <div
    class="color-option"
    [class.selected]="option === color"
    [class.primary-500-border]="option === color"
    matRipple
    [style.backgroundColor]="option"
    (click)="toggleColorPicker(option)"
  ></div>
</div>
} }
<!-- class "color-picker" reserved by the dependency -->
<div class="outer-color-option custom-color-option">
  <div
    class="onsip-color-picker color-option"
    [class.selected]="customColor === color"
    [class.primary-500-border]="customColor === color"
    disabled
    [style.background]="!customColor ? '#f6f5f5' : customColor"
    [colorPicker]="customColor"
    (colorPickerChange)="customColorPickerEvent.next($event)"
    [cpOutputFormat]="'hex'"
    [cpPosition]="'bottom'"
    [cpPositionOffset]="'50%'"
    [cpPositionRelativeToArrow]="true"
  >
    @if (!customColor) {
    <mat-icon color="primary">add</mat-icon>
    } @if (!!customColor) {
    <mat-icon [style.color]="customColor ? (customColor | textColorForCustomBackground) : '#ffffff'"
      >edit</mat-icon
    >
    }
  </div>
</div>
